webpackJsonp([35783957827783],{

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(87);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(70);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LogoLink = __webpack_require__(393);
	
	var _LogoLink2 = _interopRequireDefault(_LogoLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menu = [{
	  to: '/advanced/',
	  children: 'Advanced CSS + Javascript'
	}, {
	  to: '/wordpress/',
	  children: 'WordPress'
	}, {
	  to: '/react/',
	  children: 'React'
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex justify-center items-center f2 px-bold flex-wrap pa4' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'SuperHi \u2192 Project Guides' }),
	    _react2.default.createElement(_LogoLink2.default, null),
	    _react2.default.createElement(
	      'ul',
	      { className: 'list tc w-100 pl0' },
	      menu.map(function (item) {
	        return _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(_gatsbyLink2.default, _extends({ className: 'black link hover-blue lh-title' }, item))
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-83dba42d20fa4fbb8254.js